"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectUsers = exports.defaultParams = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var memoize = require("fast-memoize");
var classNames = require("classnames");
var sok_ui_1 = require("@caddigital/sok-ui");
var actions = require("@caddigital/sok-reducers/lib/actions/management");
var projectUsers_1 = require("@caddigital/sok-reducers/lib/epics/management/projectUsers");
var userLens_1 = require("@caddigital/sok-reducers/lib/utils/userLens");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var List_1 = require("components/modals/UserProjectsModal/List");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var search_1 = require("utils/search");
var components_1 = require("components");
var ColumnFilter_1 = require("components/ColumnFilter");
var avatars_1 = require("components/Avatar/avatars");
var text_1 = require("utils/text");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
var Types = require("types");
var constants_1 = require("utils/constants");
var SortButton = sok_ui_1.Table.SortButton;
var headers = ['user', 'project', 'userGroups'];
exports.defaultParams = {
    orderBy: 'user',
    order: 'asc'
};
var mapStateToProps = function (state) {
    return {
        projectUsers: state.management.projectUsers,
        projects: state.management.projects
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    setProject: function (project) {
        return dispatch(actions.ProjectUsers.selectProject(project));
    },
    clearProjectList: function () { return dispatch(actions.ProjectsActions.clear()); },
    setUserSearchString: function (searchString) {
        return dispatch(actions.ProjectUsers.setUserSearchString(searchString));
    },
    searchProjects: function (searchString, customer) {
        return dispatch(actions.ProjectsActions.fetchRequest({
            customer: customer.id,
            name: searchString,
            limit: 25
        }));
    },
    search: function (customer, project, user) { return dispatch(actions.ProjectUsers.fetchRequest(customer, project, user)); },
    toggleSelected: function (items, status) {
        return dispatch(actions.ProjectUsers.toggleSelect(items, status));
    },
    remove: function (items) {
        return dispatch(actions.ProjectUsers.removeRequest(items));
    },
    clear: function () { return (dispatch(actions.ProjectsActions.clear()),
        dispatch(actions.ProjectUsers.clear())); }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var filterData = function (list, filters) {
    var keys = Object.keys(filters);
    if (keys.length === 0) {
        return __spreadArray([], list, true);
    }
    return list.reduce(function (result, item) {
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var searchValue = filters[key];
            switch (key) {
                case 'user': {
                    var emailValue = item.user.email;
                    var nameValue = userLens_1.getName.get(item.user);
                    if (searchValue &&
                        emailValue &&
                        emailValue
                            .toString()
                            .toLowerCase()
                            .indexOf(searchValue.toLowerCase()) === -1 &&
                        nameValue &&
                        nameValue
                            .toString()
                            .toLowerCase()
                            .indexOf(searchValue.toLowerCase()) === -1) {
                        return result;
                    }
                    break;
                }
                case 'project': {
                    var value = item.project.name;
                    if (searchValue &&
                        value &&
                        value
                            .toString()
                            .toLowerCase()
                            .indexOf(searchValue.toLowerCase()) === -1) {
                        return result;
                    }
                    break;
                }
                case 'userGroups': {
                    var value = (0, List_1.getRolesString)(item.groups);
                    if (searchValue &&
                        value &&
                        value
                            .toString()
                            .toLowerCase()
                            .indexOf(searchValue.toLowerCase()) === -1) {
                        return result;
                    }
                    break;
                }
            }
        }
        result.push(item);
        return result;
    }, []);
};
var sortData = function (list, order, orderBy) {
    var orderMultiplier = order === 'asc' ? 1 : -1;
    return list.sort(function (a, b) {
        switch (orderBy) {
            case 'user':
                return a.user.email.localeCompare(b.user.email) * orderMultiplier;
            case 'project':
                return a.project.name.localeCompare(b.project.name) * orderMultiplier;
            case 'userGroups':
                return (0, List_1.compareRoles)(a, b) * orderMultiplier;
        }
        return 0;
    });
};
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('contentWidth', 'setContentWidth', 0), (0, recompose_1.withState)('items', 'setItems', []), (0, recompose_1.withState)('removeModal', 'setRemoveModal', null), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        var _a = this.props.queryParams, order = _a.order, orderBy = _a.orderBy, filters = __rest(_a, ["order", "orderBy"]);
        var items = filterData(this.props.projectUsers.result, filters);
        items = sortData(items, order, orderBy);
        this.props.setItems(items);
    },
    componentDidUpdate: function (prevProps) {
        var items = this.props.items;
        if (this.props.queryParams !== prevProps.queryParams ||
            (prevProps.projectUsers.result.length === 0 &&
                this.props.projectUsers.result.length) ||
            this.props.projectUsers.status !== prevProps.projectUsers.status ||
            this.props.projectUsers.result !== prevProps.projectUsers.result) {
            var _a = this.props.queryParams, order = _a.order, orderBy = _a.orderBy, filters = __rest(_a, ["order", "orderBy"]);
            items = filterData(this.props.projectUsers.result, filters);
            items = sortData(items, order, orderBy);
            this.props.setItems(items);
        }
        if (items !== prevProps.items) {
            var contentWidth_1 = 0;
            var columns_1 = items.reduce(function (p, item) {
                headers.forEach(function (x) {
                    var dataKey = '__' + x.replace(/-/g, '');
                    switch (x) {
                        case 'user': {
                            var length = Math.max((0, text_1.calculateStringLength)(userLens_1.getName.get(item.user)), (0, text_1.calculateStringLength)(item.user.email));
                            if (!p[dataKey] || p[dataKey] < length) {
                                p[dataKey] = length;
                            }
                            break;
                        }
                        case 'project': {
                            var length = (0, text_1.calculateStringLength)(item.project.name || '');
                            if (!p[dataKey] || p[dataKey] < length) {
                                p[dataKey] = length;
                            }
                            break;
                        }
                        case 'userGroups': {
                            var length = (0, text_1.calculateStringLength)((0, List_1.getRolesString)(item.groups));
                            if (!p[dataKey] || p[dataKey] < length) {
                                p[dataKey] = length;
                            }
                            break;
                        }
                    }
                });
                return p;
            }, {});
            headers.forEach(function (x) {
                var dataKey = '__' + x.replace(/-/g, '');
                var text = (0, translation_1.getLocalization)("managementVuew/column/".concat(x)).toString();
                var length = (0, text_1.calculateStringLength)(text) + 55;
                if (!columns_1[dataKey] || columns_1[dataKey] < length) {
                    columns_1[dataKey] = length;
                }
            });
            // Override styles for dynamic classes
            var style = document.getElementById('ManagementUserProjectsListCSS');
            if (style && style.parentNode) {
                style.parentNode.removeChild(style);
            }
            style = document.createElement('style');
            style.id = 'ManagementUserProjectsListCSS';
            document.head && document.head.appendChild(style);
            var sheet_1 = style.sheet;
            contentWidth_1 += 2.5 * 13;
            Object.keys(columns_1).forEach(function (className, i) {
                var colwidth = Math.max(8, 4 + columns_1[className] + 26); // convert to rem
                contentWidth_1 += colwidth;
                sheet_1.insertRule(".".concat(className) +
                    ' {max-width: ' +
                    colwidth +
                    'px;\n min-width: ' +
                    colwidth +
                    'px;}', i);
            });
            this.props.setContentWidth(contentWidth_1);
        }
        if (this.props.projectUsers.removeStatus !==
            prevProps.projectUsers.removeStatus &&
            this.props.projectUsers.removeStatus === 'FETCHED') {
            this.props.search(this.props.currentCustomer, this.props.projectUsers.selectedProject, this.props.projectUsers.userSearchString);
        }
    }
}), recompose_1.pure);
var selectorEnhance = (0, recompose_1.compose)((0, recompose_1.withState)('searchString', 'setsearchString', null), recompose_1.pure);
var projectSelectorTimer;
var ProjectSelector = selectorEnhance(function (props) { return (React.createElement(sok_ui_1.Dropdown2, null,
    React.createElement(sok_ui_1.TextInput, { placeholder: (0, translation_1.getLocalization)('management/search/project/placeholder'), onChange: function (_a) {
            var value = _a.target.value;
            if (projectSelectorTimer) {
                clearTimeout(projectSelectorTimer);
            }
            props.setsearchString(value);
            projectSelectorTimer = setTimeout(function () {
                props.onChange(value, props.currentCustomer);
                projectSelectorTimer = undefined;
            }, constants_1.SEARCH_TIMEOUT);
        }, onBlur: function () {
            if (props.searchString !== null) {
                props.setsearchString(null);
            }
        }, value: props.searchString !== null
            ? props.searchString
            : props.selectedProject
                ? props.selectedProject.name
                : '', iconRight: React.createElement("div", { className: 'right-tools' },
            props.searchString || props.selectedProject ? (React.createElement(sok_ui_1.Icon, { className: 'fa-times', onClick: function () {
                    props.setProject(undefined);
                    props.setsearchString('');
                    props.clearProjectList();
                } })) : undefined,
            React.createElement(sok_ui_1.Icon, { className: 'fa-chevron-down' })) }),
    React.createElement(sok_ui_1.Dropdown2Menu, null, props.projects.status === 'STANDBY' ? (React.createElement(sok_ui_1.Dropdown2MenuItem, { disabled: true }, (0, translation_1.getLocalization)('management/searchProjects/pleaseEnterName'))) : props.projects.status === 'FETCHING' ? (React.createElement(sok_ui_1.Dropdown2MenuItem, { disabled: true }, (0, translation_1.getLocalization)('management/searchProjects/searching'))) : props.projects.status === 'FETCHED' ? (props.projects.list.length === 0 ? (React.createElement(sok_ui_1.Dropdown2MenuItem, { disabled: true }, (0, translation_1.getLocalization)('management/searchProjects/notFound'))) : (props.projects.list.map(function (x) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { key: "project-".concat(x.id), onClick: function () { return props.setProject(x); } }, x.name)); }))) : (React.createElement(sok_ui_1.Dropdown2MenuItem, { disabled: true }, (0, translation_1.getLocalization)('management/searchProjects/failed')))))); });
function getColumn(column, value) {
    return (React.createElement("div", { className: classNames("row__column dynamic __".concat(column), column === 'name' && 'expand'), "data-key": "__".concat(column) }, value));
}
function getHeaderColumn(props, name, identifier) {
    var order = props.queryParams.orderBy === identifier &&
        props.queryParams.order === 'asc'
        ? 'desc'
        : 'asc';
    var dataKey = '__' + identifier;
    return (React.createElement("div", { key: identifier, "data-key": dataKey, "data-length": name.length, className: classNames('row__column dynamic briefcase-list-row-column', dataKey) },
        React.createElement("div", { onClick: function () {
                var params = __assign(__assign({}, props.queryParams), { order: order, orderBy: identifier });
                props.updateUrl(props.pathname + (0, search_1.getQueryParams)(params));
            } }, (0, translation_1.getLocalization)("managementView/column/".concat(name))),
        React.createElement(SortButton, { className: "d-none d-desktop-table-cell filter", order: props.queryParams.orderBy === identifier
                ? (props.queryParams.order || 'name').toLowerCase()
                : null, onChange: function () {
                var params = __assign(__assign({}, props.queryParams), { order: order, orderBy: identifier });
                props.updateUrl(props.pathname + (0, search_1.getQueryParams)(params));
            } }),
        React.createElement(ColumnFilter_1.ColumnFilter, { className: classNames(props.queryParams[identifier] ? 'active' : '', ' filter'), columnIdentifier: identifier, textInputValue: props.queryParams[identifier]
                ? props.queryParams[identifier] || ''
                : '', inputType: 'text', setColumnFilterString: function (field, value) {
                var params = __assign({}, props.queryParams);
                params[field] = value;
                props.updateUrl(props.pathname + (0, search_1.getQueryParams)(params));
            }, clearColumnFilter: function (field) {
                var params = __assign({}, props.queryParams);
                params[field] = undefined;
                props.updateUrl(props.pathname + (0, search_1.getQueryParams)(params));
            } })));
}
var NotFoundPlaceHolder = function (props) { return (React.createElement("div", __assign({}, props, { key: 'no-results', className: 'no-results' }),
    React.createElement("img", { src: (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_9'), width: 200, height: 200 }),
    React.createElement("b", null, (0, translation_1.getLocalization)("managementView/emptyList/title")),
    React.createElement("span", null, (0, translation_1.getLocalization)("managementView/emptyList/message")))); };
var Header = function (props) {
    var totalSelected = props.projectUsers.selected.length;
    var totalItems = props.projectUsers.result.length;
    var isSelected = totalItems > 0 && totalSelected === totalItems;
    return (React.createElement("div", { className: 'header row', style: props.style },
        React.createElement("div", { className: 'row__column narrow' },
            React.createElement(components_1.TableRowIcon, { circle: true, icon: 'fa-check', onClick: function (e) {
                    e.stopPropagation();
                    props.toggleSelected(props.items, !isSelected);
                }, className: isSelected ? 'selected' : null })),
        headers.map(function (header) { return getHeaderColumn(props, header, header); })));
};
var createRowData = memoize(function (style, items, selected, toggleSelection) { return ({
    style: style,
    items: items,
    selected: selected,
    toggleSelection: toggleSelection
}); });
var RowDataExtractable = Types.extractReturnType(createRowData);
var ListRow = React.memo(function (_a) {
    var index = _a.index, data = _a.data, className = _a.className, style = _a.style;
    var items = data.items, toggleSelection = data.toggleSelection, selected = data.selected;
    var row = items[index];
    var iSelected = selected.findIndex(function (x) { return x.project.id === row.project.id && x.user.id === row.user.id; }) > -1;
    return (React.createElement("div", { className: classNames('row'), style: style },
        React.createElement("div", { className: 'row__column narrow' },
            React.createElement(components_1.TableRowIcon, { circle: true, icon: 'fa-check', onClick: function (e) {
                    e.stopPropagation();
                    toggleSelection([row], !iSelected);
                }, className: iSelected ? 'selected' : null })),
        React.createElement("div", { className: 'row__column user mobile __user' },
            React.createElement("div", null, userLens_1.getName.get(row.user)),
            React.createElement("div", null, row.user.email)),
        getColumn('project', row.project.name),
        getColumn('roles', (0, List_1.getRolesString)(row.groups))));
});
exports.ProjectUsers = enhance(function (props) {
    var itemData = createRowData({}, props.items, props.projectUsers.selected, props.toggleSelected);
    return (React.createElement("div", { className: 'project-users' },
        React.createElement(sok_ui_1.Grid.Row, { className: 'search-area' },
            React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                React.createElement("label", null,
                    React.createElement(sok_ui_1.Icon, { className: 'fa-building' }),
                    ' ',
                    (0, translation_1.getLocalization)('management/search/project')),
                React.createElement(ProjectSelector, { currentCustomer: props.currentCustomer, selectedProject: props.projectUsers.selectedProject, projects: props.projects, setProject: props.setProject, onChange: props.searchProjects, clearProjectList: props.clearProjectList })),
            React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
                React.createElement("label", null,
                    React.createElement(sok_ui_1.Icon, { className: 'fa-user' }),
                    ' ',
                    (0, translation_1.getLocalization)('management/search/user')),
                React.createElement(sok_ui_1.TextInput, { placeholder: (0, translation_1.getLocalization)('management/search/user/placeholder'), value: props.projectUsers.userSearchString, onChange: function (e) { return props.setUserSearchString(e.target.value); }, iconRight: props.projectUsers.userSearchString ? (React.createElement(sok_ui_1.Icon, { className: 'fa-times', onClick: function () { return props.setUserSearchString(''); } })) : undefined }))),
        React.createElement(sok_ui_1.RequestStatusBox, { key: 'request', status: props.projectUsers.removeStatus },
            (0, translation_1.getLocalization)('management/projectUsers/remove/fetching'),
            (0, translation_1.getLocalization)('management/projectUsers/remove/fetched'),
            (0, translation_1.getLocalization)('management/projectUsers/remove/failed')),
        React.createElement("div", { className: 'tools' },
            React.createElement(sok_ui_1.Button, { size: 'large', disabled: props.projectUsers.selectedProject === undefined &&
                    props.projectUsers.userSearchString.length < 3, iconRight: React.createElement(sok_ui_1.Icon, { className: 'fa-search' }), color: 'blue', text: (0, translation_1.getLocalization)('global/search'), onClick: function () {
                    return props.search(props.currentCustomer, props.projectUsers.selectedProject, props.projectUsers.userSearchString);
                } }),
            React.createElement(sok_ui_1.Button, { size: 'large', iconRight: React.createElement(sok_ui_1.Icon, { className: 'fa-eraser' }), disabled: props.projectUsers.selectedProject === undefined &&
                    props.projectUsers.userSearchString.length === 0, color: 'blue', text: (0, translation_1.getLocalization)('global/clearFilters'), onClick: function () {
                    props.clear();
                    props.updateUrl(props.pathname + (0, search_1.getQueryParams)(exports.defaultParams));
                } }),
            React.createElement("a", { target: '_blank', href: "".concat(__APIBASEURL__, "api/user/projects?").concat((0, projectUsers_1.getFetchQuery)({
                    customer: props.currentCustomer,
                    project: props.projectUsers.selectedProject,
                    user: props.projectUsers.userSearchString
                }), "&format=excel") },
                React.createElement(sok_ui_1.Button, { size: 'large', disabled: props.projectUsers.result.length === 0, iconRight: React.createElement(sok_ui_1.Icon, { className: 'fa-file-chart-line' }), color: 'dark-gray', text: (0, translation_1.getLocalization)('management/createReport') })),
            React.createElement(sok_ui_1.Dropdown2, { disabled: props.projectUsers.selected.length === 0 },
                React.createElement(sok_ui_1.Button, { size: 'large', disabled: props.projectUsers.selected.length === 0, icon: React.createElement(sok_ui_1.Icon, { className: 'fa-times-square' }), iconRight: React.createElement(sok_ui_1.Icon, { className: 'fa-chevron-down' }), border: 'red', color: 'dark-gray', text: (0, translation_1.getLocalization)('management/removeFrom') }),
                React.createElement(sok_ui_1.Dropdown2Menu, null,
                    React.createElement(sok_ui_1.Dropdown2MenuItem, { onClick: function () {
                            var filtered = props.projectUsers.selected.reduce(function (acc, item) {
                                return item.groups.reduce(function (a, g) {
                                    if (g.type !== 'SuperAdminUserGroup' &&
                                        g.type !== 'SalesmanUserGroup' &&
                                        g.type !== 'CustomerAdminUserGroup' &&
                                        g.type !== 'CustomerVisibilityUserGroup' &&
                                        g.type !== 'ParticipantUserGroup' &&
                                        g.type !== 'ExternalUserGroup') {
                                        a.push({
                                            userId: item.user.id,
                                            groupId: g.id
                                        });
                                    }
                                    return a;
                                }, acc);
                            }, []);
                            props.setRemoveModal({
                                data: filtered,
                                row1: (0, translation_1.getLocalization)('management/removeFrom/project/message1'),
                                row2: (0, translation_1.getLocalization)('management/removeFrom/project/message2')
                            });
                        } }, (0, translation_1.getLocalization)('management/removeFrom/project')),
                    React.createElement(sok_ui_1.Dropdown2MenuItem, { onClick: function () {
                            var filtered = props.projectUsers.selected.reduce(function (acc, item) {
                                var group = item.groups.find(function (x) { return x.type === 'ProjectAdminUserGroup'; });
                                if (group) {
                                    acc.push({
                                        groupId: group.id,
                                        userId: item.user.id
                                    });
                                }
                                return acc;
                            }, []);
                            props.setRemoveModal({
                                data: filtered,
                                row1: (0, translation_1.getLocalization)('management/removeFrom/projectAdmin/message1'),
                                row2: (0, translation_1.getLocalization)('management/removeFrom/projectAdmin/message2')
                            });
                        } }, (0, translation_1.getLocalization)('management/removeFrom/projectAdmin')),
                    React.createElement(sok_ui_1.Dropdown2MenuItem, { onClick: function () {
                            var filtered = props.projectUsers.selected.reduce(function (acc, item) {
                                var group = item.groups.find(function (x) { return x.type === 'SokoBidAdminUserGroup'; });
                                if (group) {
                                    acc.push({
                                        groupId: group.id,
                                        userId: item.user.id
                                    });
                                }
                                return acc;
                            }, []);
                            props.setRemoveModal({
                                data: filtered,
                                row1: (0, translation_1.getLocalization)('management/removeFrom/sokobidAdmin/message1'),
                                row2: (0, translation_1.getLocalization)('management/removeFrom/sokobidAdmin/message2')
                            });
                        } }, (0, translation_1.getLocalization)('management/removeFrom/sokobidAdmin'))))),
        React.createElement("div", { className: 'project-users-list-container' },
            React.createElement("div", { className: 'sok-list-content project-users-list ' +
                    props.projectUsers.status.toLowerCase() },
                props.projectUsers.status === 'FAILED' && (React.createElement(GenericErrorMessage_1.default, { key: 'error', title: (0, translation_1.getLocalization)('generic/error') })),
                props.projectUsers.status === 'FETCHING' && (React.createElement("div", { key: 'loading', className: 'loading' },
                    React.createElement(sok_ui_1.LoadingSpinner, null))),
                props.projectUsers.status === 'FETCHED' && props.items && (React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                    var width = _a.width, height = _a.height;
                    return (React.createElement(sok_ui_1.List, { itemCount: props.items.length, itemData: itemData, overscanCount: 8, width: width, height: height, itemHeight: 50, itemWidth: props.contentWidth, header: React.createElement(Header, __assign({}, props)), placeholder: React.createElement(NotFoundPlaceHolder, null) }, ListRow));
                })))),
        React.createElement(ConfirmDialog_1.ConfirmDialog, { overlayClassName: 'generic-warning-confirmation-modal', isOpen: props.removeModal !== null, close: function () { return props.setRemoveModal(null); }, header: (0, translation_1.getLocalization)('genericWarningConfirmationModal/warning'), body: React.createElement(React.Fragment, null,
                React.createElement(ConfirmDialog_1.Exclamation, null),
                React.createElement("div", null,
                    React.createElement("div", { className: 'title please-confirm-text' },
                        React.createElement("h2", { className: "title" }, (0, translation_1.getLocalization)('genericWarningConfirmationModal/pleaseConfirm'))),
                    props.removeModal && (React.createElement("div", { className: 'text' },
                        React.createElement("p", null, props.removeModal.row1),
                        React.createElement("p", null, props.removeModal.row2))))), footer: React.createElement(React.Fragment, null,
                React.createElement(sok_ui_1.Button, { color: 'red', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/remove'), onClick: function () {
                        if (props.removeModal) {
                            props.remove(props.removeModal.data);
                            props.setRemoveModal(null);
                        }
                    } }),
                React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/cancel'), onClick: function () { return props.setRemoveModal(null); } })) })));
});
